var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8ffe8;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502,41.9c-8.2-7.5-19.9-10.1-30.6-6.6L21.2,183.8C9,187.8.6,198.8,0,211.7c-.6,12.9,6.6,24.6,18.5,29.8l111.3,48.7c.5,2.5,32.5,150.8,33.6,155.8,1.4,6.5,4.7,12.2,11.6,14,7,1.8,12-2.1,17.3-6,2.9-2.2,82.6-61.9,82.6-61.9l96.6,79c5.6,4.6,12.5,7,19.5,7,3.3,0,6.7-.5,10-1.7,10.2-3.4,17.7-11.7,20.2-22.2l90-382.5c2.6-10.9-1-22.3-9.2-29.9ZM199.5,318.1c0,.1-.1.3-.2.5l-18.6,65.1-20.8-96.4,142.9-79.4-99.9,104.5c-1.6,1.6-2.7,3.6-3.4,5.8ZM205.5,406.6l8.5-29.6,8.1-28.3,29,23.7-45.5,34.1ZM481.9,64.9l-90,382.5c0,.2-.1.5-.5.6-.4.1-.6,0-.8-.1l-105.7-86.5s0,0,0,0l-49-40.1,157.3-164.5c5.1-5.4,5.6-13.7,1-19.6-4.5-5.9-12.7-7.6-19.2-4l-233,129.4-111.6-48.8c-.3-.1-.5-.2-.5-.8,0-.6.2-.6.6-.8L480.8,63.9c.2,0,.5-.2.8.2.4.3.3.6.2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg1);
export default __webpack_public_path__ + "static/media/tg-1.13b659d94a4efab48d80a86c39a8523d.svg";
export { ForwardRef as ReactComponent };